import { fleetManagementApi, useActiveProjectSummary } from '@nx/state';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';

import { VERY_LONG_POLLING_INTERVAL } from '../../shared/constants';

export const useTokens = () => {
  const activeProjectSummary = useActiveProjectSummary();
  const { data, isLoading, error } = fleetManagementApi.useGetTokensQuery(activeProjectSummary?.id ?? skipToken, {
    skipPollingIfUnfocused: true,
    pollingInterval: VERY_LONG_POLLING_INTERVAL,
  });

  const tokens = useMemo(() => {
    if (data) {
      return data;
    }

    return [];
  }, [data]);

  return { tokens, isLoading, error };
};
